import { Component, EventEmitter, Input, Output } from '@angular/core';
import {
  STAFF_ROLES,
  DASHBOARD_ROLES,
  CUSTOMER_MEMBER_ROLE,
  CUSTOMER_SELF_ROLE,
} from '@careapp-group/core';

export class MemberFilterOptions {
  customer: boolean;
  family: boolean;
  teamMember: boolean;
  coordinator: boolean;
  admins: boolean;
  pending: boolean;
  showPending: boolean;

  constructor({
    customer,
    family,
    teamMember,
    coordinator,
    admins,
    pending,
    showPending,
  }: {
    customer: boolean;
    family: boolean;
    teamMember: boolean;
    coordinator: boolean;
    admins: boolean;
    pending: boolean;
    showPending: boolean;
  }) {
    this.customer = customer;
    this.family = family;
    this.teamMember = teamMember;
    this.coordinator = coordinator;
    this.admins = admins;
    this.pending = pending;
    this.showPending = showPending;
  }

  // All community filters are true.
  allCommunity(): boolean {
    return this.customer && this.family && this.teamMember && this.coordinator && this.admins;
  }

  // No community filters are true.
  noCommunity(): boolean {
    return !this.customer && !this.family && !this.teamMember && !this.coordinator && !this.admins;
  }

  // At least one community filter is true.
  someCommunity(): boolean {
    return this.customer || this.family || this.teamMember || this.coordinator || this.admins;
  }

  // All filters are true.
  allSelected(): boolean {
    return this.allCommunity() && this.pending;
  }

  // No filters are true.
  noneSelected(): boolean {
    return this.noCommunity() && !this.pending;
  }

  copyWith(data: {
    customer?: boolean;
    family?: boolean;
    teamMember?: boolean;
    coordinator?: boolean;
    admins?: boolean;
    pending?: boolean;
    showPending?: boolean;
  }): MemberFilterOptions {
    return new MemberFilterOptions({
      customer: data.customer ?? this.customer,
      family: data.family ?? this.family,
      teamMember: data.teamMember ?? this.teamMember,
      coordinator: data.coordinator ?? this.coordinator,
      admins: data.admins ?? this.admins,
      pending: data.pending ?? this.pending,
      showPending: data.showPending ?? this.showPending,
    });
  }
}

@Component({
  selector: 'member-filter',
  templateUrl: './member-filter.component.html',
  styleUrls: ['./member-filter.component.scss'],
})
export class MemberFilterComponent {
  @Input() existingFilter: MemberFilterOptions;
  @Output() onFilterChange = new EventEmitter<MemberFilterOptions>();

  STAFF_ROLES = STAFF_ROLES;
  DASHBOARD_ROLES = DASHBOARD_ROLES;
  CUSTOMER_MEMBER_ROLE = CUSTOMER_MEMBER_ROLE;
  CUSTOMER_SELF_ROLE = CUSTOMER_SELF_ROLE;

  toggleCustomer() {
    this.onFilterChange.emit(
      this.existingFilter.copyWith({ customer: !this.existingFilter.customer })
    );
  }
  toggleFamily() {
    this.onFilterChange.emit(this.existingFilter.copyWith({ family: !this.existingFilter.family }));
  }
  toggleTeamMember() {
    this.onFilterChange.emit(
      this.existingFilter.copyWith({ teamMember: !this.existingFilter.teamMember })
    );
  }
  toggleCoordinator() {
    this.onFilterChange.emit(
      this.existingFilter.copyWith({ coordinator: !this.existingFilter.coordinator })
    );
  }
  toggleAdmins() {
    this.onFilterChange.emit(this.existingFilter.copyWith({ admins: !this.existingFilter.admins }));
  }
  togglePending() {
    this.onFilterChange.emit(
      this.existingFilter.copyWith({ pending: !this.existingFilter.pending })
    );
  }
}
